import React, {Component} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faCheckCircle, faExclamationCircle} from '@fortawesome/pro-solid-svg-icons'

import styles from './ApiResponse.css'

export default class ApiResponse extends Component {

    render() {

        const {response} = this.props;
        let icon = <FontAwesomeIcon className={styles.icon} icon={faCheckCircle} size="5x" color="#78efbe"/>;

        if(response.error) {
            icon = <FontAwesomeIcon className={styles.icon} icon={faExclamationCircle} size="5x" color="#e74c3c"/>;
        }

        return (
            <div className={styles.content}>
                {icon}
                <h3>{response.message}</h3>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ApiResponse/ApiResponse.js